import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { LocalizationHelper } from "../../../../helpers"
import { GridService } from '../../../../services/grid'
import { ReferenceTypeService } from '../../../../services/reference-type'

import { IMRSelectPopoverOptions } from '../../select-popover2/select-popover.controller'
import { GridTypes } from "../../grid/grid.controller"

import { OpDataType } from "../../../../models/core"
import { ColumnInfo } from "../../../../models/custom"
import { Enums } from "../../../../models/common"
import { ColumnModel } from "../../../api/api.models"

export class ViewReferenceTypeRule implements IDataTypePanelRule {

    //#region Ctor

    public constructor(
        private readonly gridService: GridService,
        private readonly referenceTypeService: ReferenceTypeService,
    ) { }

    //#endregion

    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return this.referenceTypeService.isViewReferenceType(opDataType.idReferenceType)
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        const id = opDataType.idDataType.toString()

        return this
            .getSelectPopoverOptions(id, opDataType.idReferenceType)
            .then((selectPopoverOptions: IMRSelectPopoverOptions<any>) => {

                const item: IMRDataTypePanelFormItemOptions = {
                    dataField: opDataType.idDataType.toString(),
                    validationRules: this.getValidationRules(opDataType, isRequired),

                    editorOptions: {},
                    popoverOptions: selectPopoverOptions,

                    label: {
                        location: 'top',
                        text: opDataType.toString()
                    },

                    template: `<imr-select-grid-input-field id="${id}" options="$ctrl.popoverOptions.selectGridPopupOptions${id}"></imr-select-grid-input-field>`,

                    key: id,
                    dataType: opDataType
                }

                if (additionalOptions != null) {
                    // TODO: Placeholder for future
                }

                return item
            })
    }

    //#endregion

    // Private Methods

    private getSelectPopoverOptions(key: string, idReferenceType: Enums.ReferenceType): JQueryPromise<IMRSelectPopoverOptions<any>> {
        return this.gridService
            .getPopupColumnModelByReferenceType(idReferenceType)
            .then((columns: ColumnModel[]) => {
                return {
                    gridOptions: {
                        type: GridTypes.PAGINATED_SMALL,
                        name: key,
                        buttonsOptions: {
                            enabled: true
                        },
                        idReferenceType: idReferenceType,
                        columnsDictionary: columns,
                        getDataSourceMethod: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                            return this.referenceTypeService.getReferenceObjects(idReferenceType, {
                                filterOptions: {
                                    columns,
                                    customWhereClause,
                                },

                                pagingOptions: {
                                    pageNumber: pageNbr,
                                    pageSize,
                                }
                            }) as any;
                        },
                    }
                }
            })
    }

    private getValidationRules(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (isRequired) {
            validationRules.push({
                type: "required",
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    // Private Methods End
}
